//for that chat id who send whhat message at waht time

const ChatHistory=[
    {sender:"Agent",chatId:"2",msg:"Hi please send your AADHAR CARD copy. It isn't clear.",timestamp:"01010010011"},
    {sender:"Annie S",chatId:"2",msg:"Okay",timestamp:"01010010013"},
    {sender:"Agent",chatId:"2",msg:"Okay all done. Pay Rs. 64,00,000 now using PAY NOW button.",timestamp:"01010010021"},
    {sender:"Annie S",chatId:"2",msg:"Paid.",timestamp:"01010010013"},
    {sender:"Agent",chatId:"2",msg:"SCANNED copies of properties documents transferred in your name: (1)NOC (2)SALES DEED ...",timestamp:"01010010021"},


];
export default ChatHistory;